"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20RuleDisplay = void 0;
const NinePatch_1 = require("phaser3-rex-plugins/plugins/gameobjects/rendertexture/ninepatch/NinePatch");
const KHContainer_1 = require("./KH/KHContainer");
class Z20RuleDisplay extends KHContainer_1.KHContainer {
    constructor(scene, cx, cy, setup, showHeaderText) {
        function subArray(entity, middleStr, leftGet, rightGet) {
            return [leftGet(entity), middleStr, rightGet(entity)];
        }
        function handleDisplay(array, middleStr, leftGet, rightGet) {
            for (let i = 0; i < array.length; i += 2) {
                if (i === array.length - 1) {
                    displays.push([...subArray(array[i], middleStr, leftGet, rightGet)]);
                }
                else {
                    displays.push([...subArray(array[i], middleStr, leftGet, rightGet), null, ...subArray(array[i + 1], middleStr, leftGet, rightGet)]);
                }
            }
        }
        const displays = [['text_youare', setup.player.sprite, null, 'text_winis', 'trophy']];
        displays.push([]);
        handleDisplay(setup.entities.filter(x => x.gives !== undefined), 'text_give', (entity) => entity.sprite, (entity) => entity.gives.sprite);
        displays.push([]);
        handleDisplay(setup.entities.filter(x => x.weakness !== undefined), 'text_beat', (entity) => entity.weakness.sprite, (entity) => entity.sprite);
        displays.push([]);
        const altBottom = true;
        if (altBottom) {
            displays.push(setup.entities.filter(x => x.kills).map(x => x.sprite));
            displays.push(['text_beat', setup.player.sprite]);
        }
        else {
            handleDisplay(setup.entities.filter(x => x.kills), 'text_beat', (entity) => entity.sprite, (entity) => setup.player.sprite);
        }
        const startOff = showHeaderText ? 16 : 0;
        const spriteSize = 16;
        function lineWidth(line) {
            let w = 0;
            for (let entry of line) {
                w += spriteSize * (entry == null ? 0.5 : 1);
            }
            return w;
        }
        const rowHeight = spriteSize;
        const width = Math.max(...displays.map(x => lineWidth(x))) + 10;
        const height = rowHeight * displays.map(x => x.length == 0 ? 0.5 : 1).reduce((sum, cv) => sum + cv, 0) + 10 + startOff;
        const sx = cx - (width / 2);
        const sy = cy - (height / 2);
        super(scene, sx, sy, width, height, 0x0, 1, 0, false);
        this.setDepth(1);
        if (startOff) {
            this.add(scene.add.bitmapText(width / 2, 0.5 * 16, 'igo50', `TODAY'S RULES`).setOrigin(.5, 0).setDepth(5));
        }
        let curry = 5 + startOff;
        for (let y = 0; y < displays.length; y++) {
            const sx = Math.floor((width - lineWidth(displays[y])) / 2);
            let currx = sx;
            for (let x = 0; x < displays[y].length; x++) {
                const entity = displays[y][x];
                if (!entity) {
                    currx += 8;
                    continue;
                }
                const sprite = scene.add.sprite(currx, curry, entity).setOrigin(0);
                this.add(sprite);
                currx += 16;
            }
            curry += displays[y].length === 0 ? 8 : 16;
        }
        const bg = new NinePatch_1.default(scene, {
            x: 0, y: 0, width: width, height: height,
            key: 'border',
            columns: [5, undefined, 5],
            rows: [5, undefined, 5],
        }).setOrigin(0, 0);
        scene.add.existing(bg);
        this.add(bg);
    }
}
exports.Z20RuleDisplay = Z20RuleDisplay;
